var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEverdex = function SvgIconEverdex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m1.006-12.904.655 1.098-4.396 1.146-.66-1.097zm4.13.675h.143l.636 1.065-11.691 3.152-.995.266-.075-.124A7.9 7.9 0 0 1 4 12c0-4.412 3.59-8 8.003-8a7.98 7.98 0 0 1 5.721 2.412l.235.24-1.383.363-.078-.069a6.75 6.75 0 0 0-4.495-1.717C8.27 5.23 5.23 8.267 5.23 12c0 1.004.225 1.957.62 2.815zm1.017-2.585c.396.857.62 1.811.62 2.814 0 3.732-3.039 6.77-6.773 6.77a6.73 6.73 0 0 1-4.481-1.706l-.078-.07-1.387.364.235.24A7.97 7.97 0 0 0 11.997 20C16.41 20 20 16.412 20 12c0-1.51-.42-2.925-1.154-4.13l-.076-.125-.9.243-9.16 2.44.66 1.097z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEverdex;